module.exports = require("lodash/mapKeys");